import React, { useState } from 'react'
import { Controller } from 'react-hook-form'
import { Select, Divider } from 'antd'
import { post } from '~/utils/api'
import { FieldErrors } from 'react-hook-form'
import { FormValues } from '../AddTicket'
import { FieldController as Field } from '~/components/common/Form'

type Clients = {
  value: number
  text: string
}

type Props = {
  control: any
  tab: string | null
  errors: FieldErrors<FormValues>
  allowAnonymous: boolean
}

const { Option } = Select

const SelectClient: React.FC<Props> = ({
  tab,
  control,
  allowAnonymous,
  errors,
}) => {
  const [clients, setClients] = useState<Clients[]>([])

  const handleSearchClient = async value => {
    if (value) {
      const res = await post<Clients[]>(`clients/list/get`, { q: value })
      setClients(res)
    } else {
      setClients([])
    }
  }

  return (
    <>
      <Controller
        name="client"
        control={control}
        rules={{
          required:
            tab == 'current'
              ? intl.formatMessage({
                  id: 'tickets / view / filter / errors / name',
                })
              : false,
        }}
        render={({ field, fieldState }) => (
          <Field
            label={intl.formatMessage({
              id: 'ticket / add / current client / client',
            })}
            fieldState={fieldState}
          >
            <Select
              {...field}
              showSearch
              placeholder={intl.formatMessage({
                id: 'ticket / add / current client / choose',
              })}
              defaultActiveFirstOption={false}
              showArrow={false}
              filterOption={false}
              onSearch={handleSearchClient}
              notFoundContent={null}
              status={errors.client ? 'error' : ''}
              className="form-control full-width"
            >
              {allowAnonymous && (
                <Option value={-1}>
                  {intl.formatMessage({
                    id: 'ticket / add / anonymous client',
                  }) +
                    ' #' +
                    window.c.anonClientNextNumber}
                </Option>
              )}
              <Option
                value={0}
                className="ticket-list-add-client-option"
                disabled
              >
                <Divider className="ticket-list-add-client-divider" />
              </Option>
              {clients.map((client, index) => (
                <Option key={index} value={client.value}>
                  {client.text}
                </Option>
              ))}
            </Select>
          </Field>
        )}
      />
    </>
  )
}

export default SelectClient
